import { async } from '@firebase/util';
import axios from 'axios';
import React from 'react';
import { useSignInWithGoogle } from 'react-firebase-hooks/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import auth from '../../../firebase.init';
import Loading from '../../Shared/Loading/Loading';

const SocialLogin = () => {
    const [signInWithGoogle, user, loading, error] = useSignInWithGoogle(auth)
    const navigate = useNavigate();
    const location = useLocation();
    let from = location.state?.from?.pathname || "/";

    let errorElement;

    if (loading) {
        return <Loading></Loading>
    }

    if (error) {
        errorElement = <p className='text-danger'>Error: {error?.message}</p>
    }

    // if (user) {
    //     navigate(from, { replace: true });
    // }

    const handleSignIn = async e => {
        await signInWithGoogle()
        const accessToken = async user => {
            const { data } = await axios.post('https://damp-eyrie-36624.herokuapp.com/login')
            localStorage.setItem('accessToken', data.accessToken)
            navigate(from, { replace: true });
            console.log(user?.email)
        }
        accessToken()
    }



    return (
        <div>
            <div className='d-flex align-items-center'>
                <div style={{ height: '1px' }} className='bg-dark w-50'></div>
                <p className='mt-2 px-2'>or</p>
                <div style={{ height: '1px' }} className='bg-dark w-50'></div>
            </div>
            <h6 className='text-center'>Login using</h6>
            {errorElement}
            <div className='d-flex justify-content-around'>
                <button onClick={handleSignIn} type="button" data-mdb-ripple="true" data-mdb-ripple-color="light" className=" w-25 inline-block px-6 py-2.5 mb-5 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out bg-red-600">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512" className="mx-auto w-4 h-4">
                        <path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default SocialLogin;